<template>
  <div class="qy-wrapper">
    <div class="qy-header-wrapper">
      <div class="qy-header">企业</div>
      <div class="tab box">
        <div class="tab1 tab-item select" @click="toList">列表</div>
        <div class="tab2 tab-item" @click="toMap">地图</div>
        <div class="tab3 tab-item" @click="toTotal">统计</div>
      </div>
      <div class="btn-wrapper">
        <Button class="bkcc-btn" @click="downloadRecordCard">下载登记码</Button>
        <Button class="bkcc-btn" @click="importEnterprise">导入企业</Button>
        <Button class="bkcc-btn" @click="donwLoadList">导出企业</Button>
        <Button class="bkcc-btn" @click="addQyBtn">企业加盟</Button>
      </div>
    </div>
    <qy-card ref="qyList" :QyList="qyList" :selectRule="rule" @delQy="delQy"></qy-card>
    <div class="fenye">
      <Checkbox v-model="selectTotal">全选</Checkbox>
      <!-- <Page :total="total" class="page" :current="page" @on-change="handleChangePage" show-total /> -->
      <scroll-page class="page box_f1" :total="total" :current="page" @on-change="handleChangeScrollPage"></scroll-page>
     <div>
        <Button  style="margin-right:10px" @click="handleClickReview(1)">审核通过</Button>
         <Button  @click="handleClickReview(0)">审核未通过</Button>
     </div>
    </div>
    <Modal v-model="isShowDelete" title="删除" width="660px" @on-ok="onDelete" @on-cancel="onCancel">
      <div>确定删除该企业吗？</div>
    </Modal>
    <qy-model :qyShowModel="qyShowModel" :rule="rule" @closeModel="closeModel"></qy-model>
    <Modal
      v-model="qySuccess"
      :mask-closable="false"
      width="600"
      :footer-hide="true"
      @on-cancel="showCancel"
    >
      <div style="height:390px;width: 470px;margin:auto;padding-top:50px">
        <img src="./components/success.png" style="height: 300px;width: 100%" />
      </div>
      <div style="padding-bottom:10px;width: 120px;margin:0 auto;">
        <Button type="primary" long @click="gotoDetail">完善信息</Button>
      </div>
      <div style="width: 120px;margin:0 auto">
        <Button type="text" long @click="shaohou">稍后填写</Button>
      </div>
    </Modal>

    <Modal
      v-model="importModal"
      title="导入企业"
      width="660px"
      height="400px"
      :footer-hide="true"
      @on-cancel="closeModel"
    >
      <!--/assets/企业导入模板.xlsx-->
      <div class="note box">
        请上传符合模板要求的企业文件,支持.xlsx格式
        <a
          class="download"
          href="http://bkccshequ.oss-cn-beijing.aliyuncs.com/null/2019/4/26/qiyemoban1.xlsx"
          download="企业模板"
        >下载模板</a>
      </div>
      <Upload
        ref="upload"
        :show-upload-list="false"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :headers="header"
        :action="actionuri"
        :on-success="handleSuccess"
        :on-progress="handleProgress"
        :on-error="handleError"
      >
        <Button :loading="uploadLoading" type="primary">导入企业</Button>
      </Upload>
    </Modal>
    <add-label @closeAdd="showAddModel = false" :showAddModel="showAddModel"></add-label>
    <Modal @on-visible-change="onVisibleChange" :value="showCheckMsg" title="审核说明">
      <Input type="textarea" v-model="checkMsg" :rows="10" />
      <div slot="footer">
        <Button style="margin-right:10px" @click="showCheckMsg = false">取消</Button>
        <Button type="primary" @click="review" :loading="isLoading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import addLabel from "./components/addLabel";
import qyModel from "./components/qyModel";
import api from "../../api/index";
import qyCard from "./components/qyCard";
import scrollPage from "./components/scrollPage";
// import { constants } from "crypto";
var that;

export default {
  components: {
    qyModel,
    qyCard,
    addLabel,
    scrollPage
  },
  data() {
    return {
      selectTotal: false,
      status: "",
      checkMsg: "",
      isLoading: false,
      showCheckMsg: false,
      deleteid: "",
      isShowDelete: false,
      qyShowModel: false,
      qySuccess: false,
      qyType: "",
      page: 1,
      rows: 10,
      qyList: [],
      filterList: [],
      rule: {
        typeIdList: [], //企业类型ID集合
        serviceIdList: [], //服务类型ID集合
        companyName: "", //查询企业名称
        communityIdList: [this.$store.state.streetorcommunityid], //所要查询的行政区域ID
        checkInfo: { status: "2" }, //企业审核状
        discountType: 1,
        appType:0,
        licensePicUrl:1
      }, // 过滤器筛选类型
      showAddModel: false,
      selectIndex: 1,
      addId: "", //成功添加的企业的id
      total: 2,
      importModal: false,
      header: {
        //令牌，为上传图片使用
        token: window.sessionStorage.getItem("token")
      },
      actionuri: "",
      uploadLoading: false,
      downloadUrl: "",
      sqIdList: [],
      scroll_val:{
        scroll_id:'',
        timestamp:'',
      },
      checkboxList:[]
    };
  },
  methods: {
    onVisibleChange(val) {
      if (!val) {
        this.showCheckMsg = false;
        this.checkMsg = "";
      }
    },
    async review() {
      if (!this.checkMsg) {
        return this.$Message.info("请填写审核说明");
      }
      this.isLoading = true;
      try {
        let companyIds = this.$refs.qyList.newQyList
          .filter(item => item.isSelect)
          .map(item => item.id);
        let res = await this.$post(api.checkCompanys, {
          status: this.status,
          checkMsg: this.checkMsg,
          companyIds: companyIds.join(",")
        });
        this.showCheckMsg = false;
        this.$Message.info("操作成功");
        this._reset()
      } finally {
        this.isLoading = false;
      }
    },
    async handleClickReview(status) {
      this.status = status;
      let companyIds = this.$refs.qyList.newQyList
        .filter(item => item.isSelect)
        .map(item => item.id);

      if (!companyIds.length) {
        return this.$Message.info("请勾选企业");
      }
      this.showCheckMsg = true;
    },
    toList() {
      return;
    },
    toMap() {
      this.$router.push({ name: "qiyeMap" });
    },
    toTotal() {
      this.$router.push({ name: "qiyeTotal" });
    },
    _reset() {
      this.page = 1;
      this.qyList = [];
      this.rule = {
        typeIdList: [], //企业类型ID集合
        serviceIdList: [], //服务类型ID集合
        companyName: "", //查询企业名称
        communityIdList: this.$store.state.isJiedao
          ? []
          : [this.$store.state.streetorcommunityid],
        checkInfo: { status: "2" },
        discountType: 0,
        appType:0,
        licensePicUrl:0
      };
      that.getLabel(1);
      that.getQyList();
    },
    showCancel() {
      this.qySuccess = false;
      this.qyList = []; // 用户数据置空
      this.page = 1;
      that.getQyList();
    },
    getQyList() {
      //获取企业列表
      let url = this.urlobj.getQyList;
      this.$store.commit("updateSpinShow", true);
      let data = {
        pageNum: this.page,
        pageSize: this.rows,
        ...that.rule
      }
      this.$post(url, data)
        .then(res => {
          this.$store.commit("updateSpinShow", false);
          this.total = res.total;
          if (res.rows.length) {
            /* 初始化数据 */
            var resList = res.rows.map(item => {
              return {
                showCha: false,
                id: item.id,
                name: item.companyName,
                companyTypeList: item.companyTypeList,
                status: item.checkInfo ? item.checkInfo.status : "",
                headPicUrl: item.headPicUrl,
                service:
                  item.companyServiceList != null
                    ? item.companyServiceList.map(child => {
                        return {
                          url: child.headPicUrl,
                          name: child.propertyName
                        };
                      })
                    : []
              };
            });
            that.qyList = resList;
          }
        })
        .catch(e => {
          console.log(e);
        });
      // this.page += 1; // 分页加1
    },
    handleChangePage(val) {
      this.page = val;
      this.getQyList();
    },
    handleChangeScrollPage(val){
      if(parseInt(val) == 1){
        this.page++
      }else{
        this.page--
      }
      this.getQyList();
    },
    addQyBtn() {
      var idlist = this.rule.communityIdList;
      if (this.$store.state.isJiedao == 1) {
        if (!idlist.length || idlist.length > 1) {
          this.$Message.warning("请选择一个行政区域");
          return;
        }
      }
      //弹窗显示
      this.qyShowModel = true;
    },
    // 批量下载登记卡
    downloadRecordCard() {
      let comeIdList = this.qyList.map(item => item.id).join(",");
      let url = `${this.urlobj.walkRecordDownload}?token=${this.$store.state.access_token}&comeType=3&comeIdList=${comeIdList}`;
      window.open(url);
    },
    importEnterprise() {
      var idlist = this.rule.communityIdList;
      if (this.$store.state.isJiedao == 1) {
        if (!idlist.length || idlist.length > 1) {
          this.$Message.warning("请选择一个行政区域");
          return;
        }
      }
      let communityId = "";
      if (this.$store.state.isJiedao == 1) {
        communityId = this.rule.communityIdList.length == 0
            ? sqList.join(",")
            : this.rule.communityIdList.join(",");
      } else {
        communityId = this.$store.state.streetorcommunityid;
      }
      console.log(communityId);
      this.actionuri = this.urlobj.importFangyi+`?communityId=${communityId}`;
      this.importModal = true;
    },
    closeModel(data) {
      //弹窗关闭  是否初始化
      if (data.init) {
        this.getLabel();
        this.qyShowModel = false;
        this.importModal = false;
        this.addId = data.id;
        this.qySuccess = true;
      }
    },
    gotoDetail() {
      this.$router.push({
        name: "qiyeDetail",
        query: { companyId: that.addId }
      });
    },
    shaohou() {
      this.qySuccess = false;
      this.qyList = []; // 用户数据置空
      this.page = 1;
      that.getQyList();
    },
    delQy(id) {
      this.isShowDelete = true;
      this.deleteid = id;
    },
    onDelete() {
      var url = this.urlobj.delQy(this.deleteid);
      this.$delete(url)
        .then(res => {
          if (res.isSucceed) {
            this.$Message.success("删除成功");
            //删除企业
            this.page = 1; //  初始化分页
            this.qyList = []; // 用户数据置空
            this.getQyList();
            this.getLabel();
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(e => {});
    },
    onCancel() {
      this.isShowDelete = false;
    },
    getLabel(isFirst) {
      this.$store.commit("updateSpinShow", true);
      var getQyType = this.getQyType();
      var getService = this.getService();
      var getChildShequ = this.getChildShequ();
      Promise.all([getQyType, getService, getChildShequ]).then(res => {
        this.$store.commit("updateSpinShow", false);
        this.filterList = [];
        var new_type = {
          type: "type",
          name: "企业类型",
          children: res[0].rows.map(item => {
            return {
              name: item.dicName,
              id: item.id,
              type: item.dicType,
              companyCount: item.count ? item.count : 0
            };
          })
        };
        var new_service = {
          type: "service",
          name: "服务类型",
          children: res[1].rows.map(item => {
            return {
              name: item.dicName,
              id: item.id,
              type: item.dicType,
              companyCount: item.count ? item.count : 0,
              isSelect: false,
              childShow: true,
              headPic: item.headPicUrl,
              children: item.children.map(_item => {
                return {
                  isSelect: false,
                  label: _item.dicName,
                  type: item.dicType,
                  id: _item.id,
                  childShow: false,
                  children: [],
                  number: _item.count ? _item.count : 0
                };
              })
            };
          })
        };
        var num = 0;
        var ids = [];
        var counts = [];
        ids = res[2].rows.map(item => {
          return item.communityId;
        });
        counts = res[2].rows.map(item => {
          return item.count;
        });
        counts.forEach(item => {
          num += item;
        });
        var item1 = {
          name: "全部",
          id: ids.join(","),
          companyCount: num
        };
        var list = res[2].rows.map(item => {
          return {
            name: item.communityName,
            id: item.communityId,
            companyCount: item.count
          };
        });
        list.unshift(item1);
        if (isFirst == 1 && this.$store.state.isJiedao) {
          this.rule.communityIdList = ids;
          this.getQyList();
        }
        //匹配默认选中index
        var index1 = -1;
        list.forEach((item, index) => {
          if (item.id == this.rule.communityIdList.join(",")) {
            index1 = index;
          }
        });
        var community = {
          type: "community",
          name: "行政区域",
          children: list,
          selectedIndex: index1
        };

        if (this.$store.state.isJiedao == 1)
          this.filterList.push(new FilterItem(community));
        this.filterList.push(new FilterItem(new_type));
        this.filterList.push(new FilterItem(new_service));
        this.initFilterList(this.filterList);
      });
    },
    getChildShequ() {
      return new Promise((resolve, reject) => {
        var url = this.urlobj.getDivision("company");
        this.$get(url)
          .then(res => {
            if (res.isSucceed) {
              resolve(res);
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    /* 获取右侧筛选分类 */
    getQyType() {
      return new Promise((resolve, reject) => {
        var url = this.urlobj.getQyLabel;
        console.log(url);
        this.$get(url, {
          labelParentType: "type",
          communityIds: that.rule.communityIdList.join(",")
        })
          .then(res => {
            if (res.isSucceed) {
              resolve(res);
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getService() {
      return new Promise((resolve, reject) => {
        var url = this.urlobj.getQyLabel;
        this.$get(url, {
          labelParentType: "service",
          communityIds: this.rule.communityIdList.join(",")
        })
          .then(res => {
            if (res.isSucceed) {
              resolve(res);
            } else {
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    initFilterList(list) {
      /* search 数据 */
      let search = {
        name: "search",
        data: {},
        event: function(e) {
          that[e.fn](e);
        }
      };
      /* 认证状态对象 */
      let authState = {
        name: "authstate",
        data: {
          title: "审核状态",
          stateList: [
            {
              value: "已通过",
              stateCode: 1,
              stateColor: "#47ba54",
              active: true
            },
            {
              value: "待审核",
              stateCode: 2,
              stateColor: "#ff7744",
              active: false
            },
            {
              value: "未通过",
              stateCode: 0,
              stateColor: "#a1afb3",
              active: false
            },
            {
              value: "未提交",
              stateCode: 9,
              stateColor: "#7faffd",
              active: false
            }
          ]
        },
        event: function(e) {
          that[e.fn](e);
        }
      };
      let filterType = {
        name: "filterType",
        data: {
          title: "筛选类型",
          stateList: [
             {
              id:1,
              model: true,
              label: "已参加优惠活动",
            },
              {
              id:2,
              model: false,
              label: "已上传营业执照",
            },
              {
              id:3,
              model: false,
              label: "excel文件导入数据",
            },
          ]
        },
        event: function(e) {
          that[e.fn](e);
        }
      };
      list.unshift({}, filterType)
      list.unshift(search, authState);
     
      this.$store.commit("updateFilterList", list);
    },
    filterTypeChange(e) {
      this.checkboxList = e.params.list
      // console.log(this.checkboxList)
      this.$nextTick(function () {
        let discountType = this.checkboxList[0].model
        let licensePicUrl = this.checkboxList[1].model
        let appType = this.checkboxList[2].model
        // console.log(discountType,licensePicUrl,appType)
        this.rule.discountType = discountType?1:0
        this.rule.licensePicUrl = licensePicUrl?1:0
        this.rule.appType = appType?1:0
        this.page = 1;
        this.qyList = [];
        that.getQyList();
      })
    },
    search({ params }) {
      //右侧输入筛选
      this.page = 1; //  初始化分页
      this.qyList = []; // 用户数据置空
      this.rule.companyName = params.searchValue;
      that.getQyList();
    },
    /* ==================== 认证状态  BEGIN==================== */
    authchange({ params }) {
      this.page = 1; //  初始化分页
      this.qyList = []; // 用户数据置空
      this.rule.checkInfo.status = params.stateCode;
      that.getQyList();
    },
    /* ==================== 认证状态  END==================== */
    /* 分类模块添加分类 */
    addSort({ params }) {
      let url = this.urlobj.addLabel();
      console.log(url);
      let data = {
        labelType: 4, // 企业服务 是1
        name: params.addValue
      };
      this.$store.commit("updateSpinShow", true);
      this.$post(url, data)
        .then(res => {
          if (res.isSucceed) {
            this.$Message.success("添加成功");
            this.getLabel();
          }
        })
        .catch(e => console.log(e));
    },
    /* 删除模块删除分类 */
    delSort({ params }) {
      let target = this.filterList[params.filterListIndex];
      let delId = target.data.dataList[params.delIndex].id;
      let url = this.urlobj.delLabel(delId);
      this.$store.commit("updateSpinShow", true);
      this.$delete(url)
        .then(res => {
          this.$store.commit("updateSpinShow", false);
          if (res.isSucceed) {
            this.$Message.success("删除成功");
            target.data.dataList.splice(params.delIndex, 1);
          }
        })
        .catch(e => {
          console.log(e);
          this.$store.commit("updateSpinShow", false);
        });
    },
    /* 拖曳到分类 */
    sortDrop({ params }) {
      this.qyDrop(params);
    },
    /* 勾选筛选选项 */
    /* ==================== 分类  END==================== */
    /* ==================== 行政区域  BEGIN==================== */
    areaChange({ params }) {
      console.log("行政区域筛选");
      this.qySelectType(params);
    },
    sortChange({ params }) {
      this.qySelectType(params);
    },
    addOriChange({ params }) {
      this.qySelectType(params);
    },
    orgChange({ params }) {
      this.qySelectType(params);
    },
    orgDrop({ params }) {
      console.log("11111111111");
      this.qyDrop(params);
    },
    donwLoadList() {
      var idlist = this.rule.communityIdList;
      console.log(idlist);
      if (this.$store.state.isJiedao == 1) {
        if (!idlist.length) {
          this.$Message.warning("请选择一个行政区域");
          return;
        }
      }
      let url = this.urlobj.downQy;
      // console.log(this.filterList)
      var sqList = [];
      this.filterList.forEach(item => {
        if (item.type == "community")
          sqList = item.data.dataList.map(_item => {
            return _item.id;
          });
      });
      var communityIds = "";
      if (this.$store.state.isJiedao == 1) {
        communityIds =
          this.rule.communityIdList.length == 0
            ? sqList.join(",")
            : this.rule.communityIdList.join(",");
      } else {
        communityIds = this.$store.state.streetorcommunityid;
      }
      if (communityIds.indexOf(",") != -1) {
        communityIds = "";
      }
      var typeIds =
        this.rule.typeIdList.length == 0 ? "" : this.rule.typeIdList.join(",");
      var serviceIds =
        this.rule.serviceIdList.length == 0
          ? ""
          : this.rule.serviceIdList.join(",");
      console.log(communityIds);
      url =
        url +
        "?communityIds=" +
        communityIds +
        "&checkStatus=" +
        this.rule.checkInfo.status +
        "&companyName=" +
        this.rule.companyName +
        "&token=" +
        this.header.token;
      console.log(url);
      window.open(url);
    },
    qySelectType(e) {
      console.log(e);
      let target = this.filterList[e.filterListIndex];
      this.page = 1; //  初始化分页
      this.qyList = []; // 用户数据置空
      console.log(target);
      if (target.type == "service") {
        this.rule.serviceIdList = e.selectedIndex.map(item => {
          return item;
        });
      } else if (target.type == "community") {
        var val1 = target.data.dataList[e.selectedIndex].id;
        var index = String(val1).indexOf(",");
        var idlist = index == -1 ? [val1] : val1.split(",");
        this.rule.communityIdList = idlist;
        this.getLabel();
      } else if (target.type == "type") {
        this.rule.typeIdList = e.selectedIndex.map(item => {
          return target.data.dataList[item].id;
        });
      }
      that.getQyList();
    },
    qyDrop(e) {
      console.log(e);
      let target = this.filterList[e.filterListIndex];
      console.log(this.filterList[e.filterListIndex]);
      let url = this.urlobj.getQyType;
      let data = {
        companyId: e.dropValue
      };
      if (target.type == "service") {
        data.labelId = target.data.dataList[e.elIndex].id;
      } else if (target.type == "type") {
        data.typeId = target.data.dataList[e.elIndex].id;
      }
      this.$store.commit("updateSpinShow", true);
      this.$post(url, data)
        .then(res => {
          this.$store.commit("updateSpinShow", false);
          if (res.isSucceed) {
            this.$Message.success("添加成功");
            this.filterList[e.filterListIndex].data.dataList[e.elIndex]
              .number++;
            this.qyList = []; // 用户数据置空
            this.page = 1;
            that.getQyList();
          }
        })
        .catch(e => {
          this.$store.commit("updateSpinShow", false);
          console.log(e);
        });
    },
    //右侧标签点击添加  弹出model
    showModel() {
      this.showAddModel = true;
    },
    handleProgress() {
      this.uploadLoading = true;
    },
    handleSuccess() {
      this.uploadLoading = false;
      this.importModal = false;
      this.$Message.success("导入成功");
      this.page = 1;
      that.getLabel();
      this.getQyList();
    },
    handleError() {
      this.uploadLoading = false;
      this.importModal = false;
      this.$Message.error("导入失败");
    }
  },
  created() {
    that = this;
    this.reset = this._.debounce(this._reset, 100); // filter 重置后会触发
    this.actionuri = this.urlobj.importFangyi;
  },
  watch: {
    /* 当前total发生变化时 右侧label显示跟着变化 */
    total(newVal) {
      this.$store.commit("updateLabelList", [
        {
          name: "filter_label",
          data: {
            label: "当前总数",
            value: newVal
          }
        }
      ]);
    },
    selectTotal(val) {
      if(val){
        this.$refs.qyList.newQyList = this.$refs.qyList.newQyList.map(item => {
          if(item.status == 2){
            item.isSelect = true
          }
          return item
        })
      }else{
        this.$refs.qyList.newQyList = this.$refs.qyList.newQyList.map(item => {
          if(item.status == 2){
            item.isSelect = false
          }
          return item
        })
      }
    }
  },
  handleProgress() {
    this.uploadLoading = true;
  },
  handleSuccess() {
    this.uploadLoading = false;
    this.importModal = false;

    this.$Message.success("导入成功");
    this.page = 1;
    this.getQyList();
    this.getLabel();
  },
  mounted() {
    that.getLabel(1);
    if (!this.$store.state.isJiedao) that.getQyList();
  },
  destroyed() {
    console.log("[sys] userEnterprise destroyed");
    this.$store.commit("updateFilterList", []);
    this.$store.commit("updateLabelList", []);
  }
};
/* ---------------------------筛选组件构造对象 --------------------------*/
/*
      type : 用来确定 使用哪个组件
      name ：组件显示的头部文字
      children: 子列表数据
    */

function FilterItem({ type, name, children, selectedIndex }) {
  // console.log('[fn] FilterItem excuted');
  /* 是否可编辑 以后扩展*/
  this.editMode = function(type) {
    switch (type) {
      case "service":
        this.name = "addOrigin";
        break;
      case "type":
        this.name = "microorg";
        break;
      default:
        return false;
    }
  };
  /* 初始化 组件类型 this.name 确定组件类型*/
  switch (type) {
    case "service":
      this.name = "sort";
      break;
    case "type":
      this.name = "microorg";
      break;
    case "community":
      this.name = "singleDivision";
      break;
  }
  /* 对象类型 */
  this.type = type;
  /* 初始化对象 数据 */
  this.data = {
    title: name, // 解构过来的name
    edit: this.editMode(type),
    dataList: children.map((item, index) => {
      return {
        id: item.id,
        label: item.name,
        number: item.companyCount,
        iconPath: "",
        type: item.type || "",
        children: item.children ? item.children : [],
        isSelect: false,
        childShow: true,
        headPic: item.headPic ? item.headPic : ""
      };
    })
  };
  if (selectedIndex > -1) {
    console.log(111);
    this.data.selectedIndex = selectedIndex;
  }
  /* 初始化对象事件 写死的 由当前组件对象去处理业务逻辑，没有相关函数会报错*/
  this.event = function(e) {
    that[e.fn](e);
  };
}
</script>

<style lang="less" scoped>
.qy-header-wrapper {
  display: flex;
  /*height: 30px;*/
  line-height: 30px;
  padding-top: 30px;
  justify-content: center;
  position: relative;
}

.qy-header {
  font-size: 25px;
  text-align: center;
}
.select {
  background: #ff7b44;
  color: #fff;
}
.select {
  background: #ff7b44;
  color: #fff;
}
.tab {
  position: absolute;
  left: 20px;
  background: #fff;
  color: #a0a0a0;
  border-radius: 5px;
  font-size: 14px;
}
.tab1 {
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
}
.tab2 {
  /*background: #ff7b44;*/
  /*color:#fff*/
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
}
.tab3 {
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}
.tab-item {
  // width: 50px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  padding: 0px 15px;
  cursor: default;
}
// 分页组件
.fenye {
  // width: 100%;
  background: #fff;
  position: fixed;
  bottom: 0;
  height: 40px;
  right: 255px;
  left: 150px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  justify-content: space-between;
}

.page {
  margin-left: 50px
}

.note {
  font-size: 16px !important;
  margin-bottom: 20px;
  .download {
    color: #ff7b44;
    text-decoration: underline;
    margin-left: 5px;
  }
}

.uploadkuang {
  position: relative;
  height: 100px;
}

.filename {
  font-size: 14px;
  margin-top: 10px;
  margin-right: 10px;
}

.deletefile {
  font-size: 14px;
  margin-top: 10px;
  color: #576b95;
}
.btn-wrapper {
  position: absolute;
  right: 20px;
  display: flex;
}
</style>
